/* global swal, _, angular*/
import './style.less';
import templateCheckbox from './template.checkbox.html';
import templateList from './template.list.html';
import templateSearch from './template.search.html';
import { flatten } from 'lodash';

export default function($log, $sce, $timeout, ApiClass, ProfileClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  const { profile: { company_id, profile_uid } = {} } = ProfileClass.profileComplete;

  vm.profile_uid = profile_uid;
  vm.changeCheckbox = () => {
    const selectedTags = flatten(
      vm.tagGroups.reduce((arr, tagGroup) => {
        const selectedTags = [];
        const selectedNames = [];

        Object.values(tagGroup.tags).forEach(({ selected, name, uuid }) => {
          if (selected) {
            selectedNames.push(name);
            selectedTags.push(uuid);
          }
        });

        tagGroup.names = selectedNames;
        tagGroup.selectedTags = selectedTags;
        arr.push([...selectedTags]);

        return arr;
      }, [])
    );

    callBack(selectedTags);
  };

  vm.changeSearch = () => {
    const selectedTags = flatten(vm.tagGroups.map(({ selectedTags }) => selectedTags || []));

    callBack(selectedTags);
  };

  function callBack(selectedTags) {
    vm.ngModel = selectedTags;

    if (vm.action) {
      $timeout(() => {
        vm.action();
      }, 0);
    }
  }

  function expose(tagItems) {
    if (!tagItems || !tagItems.length) return [];

    vm.tagGroups = tagItems
      .map(tagGroup => {
        const { tags } = tagGroup;

        tagGroup.selectedTags = [];

        tagGroup.tagsList = Object.values(tags).forEach(tag => {
          const { uuid } = tag;
          if (vm.ngModel && vm.ngModel.includes(uuid)) {
            tag.selected = true;
            tagGroup.selectedTags.push(uuid);
          }
        });

        tagGroup.tagsList = Object.values(tags).filter(({ uuid }) => {
          return !vm.existingTags || vm.existingTags.includes(uuid);
        });

        return tagGroup;
      })
      .filter(({ tagsList }) => {
        return tagsList && tagsList.length;
      });
  }

  function setClasses() {
    const labelClasses = { true: 'sr-only', false: 'col-lg-2 col-md-3 col-sm-4 col-xs-12' }[!!vm.hideLabel];
    const inputClasses = {
      true: 'col-lg-12 col-md-12 col-sm-12 col-xs-12',
      false: 'col-lg-10 col-md-9 col-sm-8 col-xs-12'
    }[!!vm.hideLabel];
    const wrapperClasses = 'col-lg-12 col-md-12 col-sm-12 col-xs-12';

    vm.wrapperClasses = vm.wrapperColumn || wrapperClasses;
    vm.labelClasses = vm.labelColumn || labelClasses;
    vm.inputClasses = vm.inputColumn || inputClasses;
  }

  function setView() {
    vm.style = vm.style || 'search';
    vm.template = $sce.trustAsHtml(
      { checkbox: templateCheckbox, list: templateList, search: templateSearch }[vm.style || 'search']
    );
  }

  function activate() {
    $log.debug('Tags Search Component Activated');

    if (!company_id) return;

    setClasses();
    setView();

    vm.showLimit = vm.showLimit || 3;

    const allowedItemTypes = vm.allowedItemType && [vm.allowedItemType];

    ApiClass.companiesIdTypeGet({ manage: false, id: company_id, type: 'tagCategories' }, null, {
      queryParams: { filter: JSON.stringify({ allowedItemTypes }) }
    })
      .then(({ data: { items: tagCategory } }) => expose(tagCategory))
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/tagsSelect/controller.js